(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("classnames"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "classnames", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["ReactContexify"] = factory(require("react"), require("prop-types"), require("classnames"), require("react-dom"));
	else
		root["ReactContexify"] = factory(root["react"], root["prop-types"], root["classnames"], root["react-dom"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_14__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 12);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* css classes mapping
* */
exports.default = {
  MENU: 'react-contexify',
  SEPARATOR: 'react-contexify__separator',
  ITEM: 'react-contexify__item',
  ITEM_DISABLED: 'react-contexify__item--disabled',
  ITEM_DATA: 'react-contexify__item__data',
  ITEM_ICON: 'react-contexify__item__icon',
  THEME: 'react-contexify__theme--',
  ANIMATION_WILL_ENTER: 'react-contexify__will-enter--',
  ANIMATION_WILL_LEAVE: 'react-contexify__will-leave--'
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint no-unused-expressions: ["error", { "allowShortCircuit": true }] */

var eventManager = {
  eventList: new Map(),
  token: 0,

  on: function on(event, callback) {
    this.eventList.has(event) || this.eventList.set(event, []);
    this.token += 1;
    this.eventList.get(event).push({
      token: this.token,
      callback: callback
    });

    return this.token;
  },
  off: function off(event) {
    var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (token === null) {
      return this.eventList.delete(event);
    }
    var events = this.eventList.get(event).filter(function (e) {
      return e.token !== token;
    });
    this.eventList.set(event, events);
  },
  has: function has(event) {
    return this.eventList.has(event);
  },
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!this.eventList.has(event)) {
      console.warn("<" + event + "> Event is not registered. Did you forgot to bind the event ?");
      return false;
    }
    this.eventList.get(event).forEach(function (listener) {
      var _listener$callback;

      return (_listener$callback = listener.callback).call.apply(_listener$callback, [_this].concat(_toConsumableArray(args)));
    });
    return true;
  }
};

exports.default = eventManager;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _eventManager = __webpack_require__(3);

var _eventManager2 = _interopRequireDefault(_eventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContextMenuProvider = function (_PureComponent) {
  _inherits(ContextMenuProvider, _PureComponent);

  function ContextMenuProvider(props) {
    _classCallCheck(this, ContextMenuProvider);

    var _this = _possibleConstructorReturn(this, (ContextMenuProvider.__proto__ || Object.getPrototypeOf(ContextMenuProvider)).call(this, props));

    _this.handleEvent = function (e) {
      e.preventDefault();
      _eventManager2.default.emit('display::' + _this.props.id, e.nativeEvent, _this.childrenRefs.length === 1 ? _this.childrenRefs[0] : _this.childrenRefs, _this.props.data);
    };

    _this.childrenRefs = [];
    return _this;
  }

  _createClass(ContextMenuProvider, [{
    key: 'getChildren',
    value: function getChildren() {
      var _this2 = this;

      var _props = this.props,
          id = _props.id,
          renderTag = _props.renderTag,
          event = _props.event,
          children = _props.children,
          className = _props.className,
          style = _props.style,
          rest = _objectWithoutProperties(_props, ['id', 'renderTag', 'event', 'children', 'className', 'style']);

      // reset refs


      this.childrenRefs = [];
      // use a new ref callback function each time, so that it is guaranteed to be called on each render
      var setChildRef = function setChildRef(ref) {
        return ref === null || _this2.childrenRefs.push(ref);
      };

      return _react.Children.map(this.props.children, function (child) {
        return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, _extends({}, rest, { ref: setChildRef })) : child;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _Object$assign;

      var _props2 = this.props,
          renderTag = _props2.renderTag,
          event = _props2.event,
          className = _props2.className,
          style = _props2.style;

      var attributes = Object.assign({}, (_Object$assign = {}, _defineProperty(_Object$assign, event, this.handleEvent), _defineProperty(_Object$assign, 'className', className), _defineProperty(_Object$assign, 'style', style), _Object$assign));

      return (0, _react.createElement)(renderTag, attributes, this.getChildren());
    }
  }]);

  return ContextMenuProvider;
}(_react.PureComponent);

ContextMenuProvider.propTypes = {
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
  renderTag: _propTypes2.default.node,
  event: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  data: _propTypes2.default.object
};
ContextMenuProvider.defaultProps = {
  renderTag: 'div',
  event: 'onContextMenu',
  className: '',
  style: {},
  data: null
};
exports.default = ContextMenuProvider;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _cssClasses = __webpack_require__(1);

var _cssClasses2 = _interopRequireDefault(_cssClasses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_PureComponent) {
  _inherits(Item, _PureComponent);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      _this.props.disabled ? e.stopPropagation() : _this.props.onClick(_this.props.targetNode, _this.props.refsFromProvider, _this.props.data, _this.props.outerData);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Item, [{
    key: 'buildItem',
    value: function buildItem() {
      return _react2.default.createElement(
        'div',
        { className: _cssClasses2.default.ITEM_DATA },
        this.props.leftIcon,
        this.props.children,
        this.props.rightIcon
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)(_cssClasses2.default.ITEM, _defineProperty({}, '' + _cssClasses2.default.ITEM_DISABLED, this.props.disabled));

      return _react2.default.createElement(
        'div',
        { className: className, onClick: this.handleClick, role: 'presentation' },
        this.buildItem()
      );
    }
  }]);

  return Item;
}(_react.PureComponent);

Item.propTypes = {
  children: _propTypes2.default.node.isRequired,
  targetNode: _propTypes2.default.object,
  leftIcon: _propTypes2.default.node,
  rightIcon: _propTypes2.default.node,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  data: _propTypes2.default.any,
  outerData: _propTypes2.default.any,
  refsFromProvider: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.object)])
};
Item.defaultProps = {
  leftIcon: '',
  rightIcon: '',
  disabled: false,
  onClick: function onClick() {},
  targetNode: {},
  data: null,
  outerData: null,
  refsFromProvider: []
};
exports.default = Item;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _Item = __webpack_require__(6);

var _Item2 = _interopRequireDefault(_Item);

var _cssClasses = __webpack_require__(1);

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _eventManager = __webpack_require__(3);

var _eventManager2 = _interopRequireDefault(_eventManager);

var _childrenOfType = __webpack_require__(13);

var _childrenOfType2 = _interopRequireDefault(_childrenOfType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global: window */


var ContextMenu = function (_Component) {
  _inherits(ContextMenu, _Component);

  function ContextMenu(props) {
    _classCallCheck(this, ContextMenu);

    var _this = _possibleConstructorReturn(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).call(this, props));

    _this.bindWindowEvent = function () {
      window.addEventListener('resize', _this.hide);
      window.addEventListener('contextmenu', _this.hide);
      window.addEventListener('mousedown', _this.hide);
      window.addEventListener('click', _this.hide);
      window.addEventListener('scroll', _this.hide);
    };

    _this.unBindWindowEvent = function () {
      window.removeEventListener('resize', _this.hide);
      window.removeEventListener('contextmenu', _this.hide);
      window.removeEventListener('mousedown', _this.hide);
      window.removeEventListener('click', _this.hide);
      window.removeEventListener('scroll', _this.hide);
    };

    _this.onMouseEnter = function () {
      return window.removeEventListener('mousedown', _this.hide);
    };

    _this.onMouseLeave = function () {
      return window.addEventListener('mousedown', _this.hide);
    };

    _this.hide = function (e) {
      // Firefox trigger a click event when you mouse up on contextmenu event
      if (typeof e !== 'undefined' && e.button === 2 && e.type !== 'contextmenu') {
        return;
      }
      _this.unBindWindowEvent();
      _this.setState({ visible: false });
    };

    _this.setRef = function (ref) {
      _this.menu = ref;
    };

    _this.cloneItem = function (item) {
      return _react2.default.cloneElement(item, {
        targetNode: _this.state.targetNode,
        refsFromProvider: _this.refsFromProvider,
        outerData: _this.state.data
      });
    };

    _this.show = function (e, refsFromProvider, data) {
      e.stopPropagation();
      _eventManager2.default.emit('hideAll');
      _this.refsFromProvider = refsFromProvider;

      var _this$getMousePositio = _this.getMousePosition(e),
          x = _this$getMousePositio.x,
          y = _this$getMousePositio.y;

      _this.setState({
        visible: true,
        x: x,
        y: y,
        targetNode: e.target,
        data: data
      }, _this.setMenuPosition);
    };

    _this.state = {
      x: 0,
      y: 0,
      visible: false,
      targetNode: null
    };
    _this.menu = null;
    _this.refsFromProvider = null;
    _this.token = null;
    return _this;
  }

  _createClass(ContextMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _eventManager2.default.on('display::' + this.props.id, function (e, refsFromProvider, data) {
        return _this2.show(e, refsFromProvider, data);
      });
      this.token = _eventManager2.default.on('hideAll', this.hide);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _eventManager2.default.off('display::' + this.props.id);
      _eventManager2.default.off('hideAll', this.token);
    }
  }, {
    key: 'setMenuPosition',
    value: function setMenuPosition() {
      var browserSize = {
        width: window.innerWidth,
        height: window.innerHeight
      };

      var menuSize = {
        width: this.menu.offsetWidth,
        height: this.menu.offsetHeight
      };

      var _state = this.state,
          x = _state.x,
          y = _state.y;


      if (x + menuSize.width > browserSize.width) {
        x -= x + menuSize.width - browserSize.width;
      }

      if (y + menuSize.height > browserSize.height) {
        y -= y + menuSize.height - browserSize.height;
      }

      this.setState({
        x: x,
        y: y
      }, this.bindWindowEvent);
    }
  }, {
    key: 'getMousePosition',
    value: function getMousePosition(e) {
      var pos = {
        x: e.clientX,
        y: e.clientY
      };

      if (e.type === 'touchend' && (pos.x === null || pos.y === null)) {
        var touches = e.changedTouches;

        if (touches !== null && touches.length > 0) {
          pos.x = touches[0].clientX;
          pos.y = touches[0].clientY;
        }
      }
      // just covering my ass I guess
      if (pos.x === null || pos.x < 0) {
        pos.x = 0;
      }

      if (pos.y === null || pos.y < 0) {
        pos.y = 0;
      }

      return pos;
    }
  }, {
    key: 'getMenuItem',
    value: function getMenuItem() {
      return _react2.default.Children.map(_react2.default.Children.toArray(this.props.children).filter(_react.isValidElement), this.cloneItem);
    }
  }, {
    key: 'getMenuStyle',
    value: function getMenuStyle() {
      return _extends({
        left: this.state.x,
        top: this.state.y + 1,
        opacity: 1
      }, this.props.style);
    }
  }, {
    key: 'getMenuClasses',
    value: function getMenuClasses() {
      var _cx;

      var _props = this.props,
          theme = _props.theme,
          animation = _props.animation,
          className = _props.className;


      return (0, _classnames2.default)(className, _cssClasses2.default.MENU, (_cx = {}, _defineProperty(_cx, _cssClasses2.default.THEME + theme, theme !== null), _defineProperty(_cx, _cssClasses2.default.ANIMATION_WILL_ENTER + animation, animation !== null), _cx));
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.visible ? _react2.default.createElement(
        'div',
        {
          className: this.getMenuClasses(),
          style: this.getMenuStyle(),
          ref: this.setRef,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave
        },
        _react2.default.createElement(
          'div',
          null,
          this.getMenuItem()
        )
      ) : null;
    }
  }]);

  return ContextMenu;
}(_react.Component);

ContextMenu.propTypes = {
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  children: (0, _childrenOfType2.default)(_Item2.default).isRequired,
  theme: _propTypes2.default.string,
  animation: _propTypes2.default.string,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
};
ContextMenu.defaultProps = {
  theme: null,
  animation: null,
  style: {},
  className: ""
};
ContextMenu.THEME = {
  light: 'light',
  dark: 'dark'
};
ContextMenu.ANIMATION = {
  fade: 'fade',
  flip: 'flip',
  pop: 'pop',
  zoom: 'zoom'
};
exports.default = ContextMenu;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _cssClasses = __webpack_require__(1);

var _cssClasses2 = _interopRequireDefault(_cssClasses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconFont = function (_PureComponent) {
  _inherits(IconFont, _PureComponent);

  function IconFont() {
    _classCallCheck(this, IconFont);

    return _possibleConstructorReturn(this, (IconFont.__proto__ || Object.getPrototypeOf(IconFont)).apply(this, arguments));
  }

  _createClass(IconFont, [{
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)(_cssClasses2.default.ITEM_ICON, this.props.className);
      var attributes = Object.assign({ className: className }, Object.keys(this.props.style).length > 0 ? { style: this.props.style } : {});

      return _react2.default.createElement(
        'i',
        attributes,
        this.props.children
      );
    }
  }]);

  return IconFont;
}(_react.PureComponent);

IconFont.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  children: _propTypes2.default.node
};
IconFont.defaultProps = {
  className: '',
  style: {},
  children: ''
};
exports.default = IconFont;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cssClasses = __webpack_require__(1);

var _cssClasses2 = _interopRequireDefault(_cssClasses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Separator = function Separator() {
  return _react2.default.createElement('div', { className: _cssClasses2.default.SEPARATOR });
};

exports.default = Separator;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (id) {
  return function (TargetComponent) {
    var renderTag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
    var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'onContextMenu';
    var className = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var style = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    return function (props) {
      return _react2.default.createElement(
        _ContextMenuProvider2.default,
        {
          id: id,
          renderTag: renderTag,
          event: event,
          className: className,
          style: style
        },
        (0, _react.createElement)(TargetComponent, props)
      );
    };
  };
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ContextMenuProvider = __webpack_require__(5);

var _ContextMenuProvider2 = _interopRequireDefault(_ContextMenuProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Component) {
  return function (_PureComponent) {
    _inherits(WithProxy, _PureComponent);

    function WithProxy() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WithProxy);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithProxy.__proto__ || Object.getPrototypeOf(WithProxy)).call.apply(_ref, [this].concat(args))), _this), _this.node = null, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WithProxy, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        this.appendToBody(this.props);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.removeFromBody();
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        this.removeFromBody();
        this.appendToBody(nextProps);
      }
    }, {
      key: "removeFromBody",
      value: function removeFromBody() {
        (0, _reactDom.unmountComponentAtNode)(this.node);
        document.body.removeChild(this.node);
      }
    }, {
      key: "appendToBody",
      value: function appendToBody(props) {
        var container = document.createElement("div");
        this.node = document.body.appendChild(container);
        (0, _reactDom.render)(_react2.default.createElement(Component, _extends({}, props, { key: props.id })), this.node);
      }
    }, {
      key: "render",
      value: function render() {
        return null;
      }
    }]);

    return WithProxy;
  }(_react.PureComponent);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerContextMenu = exports.ContextMenu = exports.IconFont = exports.menuProvider = exports.ContextMenuProvider = exports.Separator = exports.Item = undefined;

var _Item = __webpack_require__(6);

Object.defineProperty(exports, 'Item', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Item).default;
  }
});

var _Separator = __webpack_require__(9);

Object.defineProperty(exports, 'Separator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Separator).default;
  }
});

var _ContextMenuProvider = __webpack_require__(5);

Object.defineProperty(exports, 'ContextMenuProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ContextMenuProvider).default;
  }
});

var _menuProvider = __webpack_require__(10);

Object.defineProperty(exports, 'menuProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_menuProvider).default;
  }
});

var _IconFont = __webpack_require__(8);

Object.defineProperty(exports, 'IconFont', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconFont).default;
  }
});

var _ContextMenu = __webpack_require__(7);

var _ContextMenu2 = _interopRequireDefault(_ContextMenu);

var _withProxy = __webpack_require__(11);

var _withProxy2 = _interopRequireDefault(_withProxy);

var _eventManager = __webpack_require__(3);

var _eventManager2 = _interopRequireDefault(_eventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ctx = (0, _withProxy2.default)(_ContextMenu2.default);

exports.ContextMenu = Ctx;
var triggerContextMenu = exports.triggerContextMenu = function triggerContextMenu(id, elem, data) {
  _eventManager2.default.emit('display::' + id, elem, null, data);
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

function withRequired(fn) {
  fn.isRequired = function (props, propName, componentName) {
    var prop = props[propName];

    if (typeof prop === 'undefined') {
      return new Error('The prop ' + propName + ' is marked as required in \n      ' + componentName + ', but its value is undefined.');
    }

    fn(props, propName, componentName);
  };
  return fn;
}

var childrenOfType = function childrenOfType(type) {
  return withRequired(function (props, propName, componentName) {
    var prop = props[propName];
    var check = null;

    _react.Children.forEach(prop, function (child) {
      // Allow null for conditional rendering: condition && <item>foo</item>
      if (child !== null && child.type !== type) {
        check = new Error(componentName + ' expect children to be of type ' + type);
      }
    });

    return check;
  });
};

exports.default = childrenOfType;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// dist/ReactContexify.min.js